import React from "react";

const ProvidentFund = () => {
    return <div>ProvidentFund</div>
}

export default ProvidentFund;